import { PublicContentShareStatusResponse } from "@authory-packages/core";
import {
    getServerSidePropsWithContentItem,
    V3ContentItemPublicPageLayoutContainer
} from "../../../../pagelayouts/content-details/ContentDetailsPublicPageLayoutContainer";
import { ContentItemAccessGate } from "../../../../pages-components/ContentItemAccessGate/ContentItemAccessGate";

export default function ContentItemStandalonePublicPage({ contentItemShareStatus }: { contentItemShareStatus: PublicContentShareStatusResponse }) {
    return (
        <ContentItemAccessGate contentItemShareStatus={contentItemShareStatus} isStandaloneContentItemView>
            <V3ContentItemPublicPageLayoutContainer
                isStandaloneCollectionView={false}
                isStandaloneContentItemView
                useProfileSmartShareEndpoint={false}
                useArticleSmartShareEndpoint={false}
            />
        </ContentItemAccessGate>
    );
}

export const getServerSideProps = getServerSidePropsWithContentItem(false, false, false);
